<template>
    <a
        v-if='href'
        class='button'
        :class='[modifierClasses, stateClasses]'
        :tabindex='isDisabled || isPending ? -1 : 0'
        :href='href'>
        <span v-if='isPending'>Loading&hellip;</span>
        <span v-else v-html='label' />
    </a>
    <button
        v-else
        type='button'
        class='button'
        :class='[modifierClasses, stateClasses]'
        :tabindex='isDisabled || isPending ? -1 : 0'
        @click='action'
        @keydown.enter='(!isDisabled && !isPending) ? action() : false'>
        <span v-if='isPending'>Loading&hellip;</span>
        <span v-else v-html='label' />
    </button>
</template>

<script>
import { stateClasses, getModifierClasses } from '@/utils/markup';


export default {
    props: {
        label: {
            type: String,
            required: true
        },
        route: {
            type: Object
        },
        href: {
            type: String,
            required: false
        },
        variants: {
            type: [String, Array],
            default: ''
        },
        isDisabled: {
            type: Boolean,
            default: false
        },
        isPending: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        modifierClasses () {
            return getModifierClasses('button', this.variants);
        },
        stateClasses () {
            return {
                [stateClasses.DISABLED]: this.isDisabled,
                [stateClasses.PENDING]: this.isPending
            };
        }
    },
    methods: {
        action () {
            const route = this.route;
            if (route) {
                this.$router.push(route);
            }
            this.$emit('action');
        }
    }
};
</script>
